import TeenTopOpenPage from "../teen41/TeenTopOpenPage";

export default function TeenPatti42() {
  return <TeenTopOpenPage gameType="teen42" title="Jack Top Open Teenpatti" />;
}
